import { LogGroup } from "../.././MyHelpers";
export class Acceleration
{
	public targetSpeed: number = 0;
	public targetDistance: number = 0;
	public duration: number = 0;
	public acceleration: number = 0;

	protected logGroup: LogGroup;

	public constructor(logGroup: LogGroup)
	{
		this.logGroup = logGroup.Add("Acceleration");
	}


	public CalculateDistance(time: number): number {
		return this.acceleration * time * time / 2;
	}
}